import { render, staticRenderFns } from "./Error_500.vue?vue&type=template&id=50f1a5a0"
import script from "./Error_500.vue?vue&type=script&lang=js"
export * from "./Error_500.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports